import * as React from 'react';
import { MobXProviderContext } from 'mobx-react';
import RootStore from 'src/stores/RootStore';

function useStores(): RootStore {
  // asserting MobXProviderContext as RootStore since there is no other way to override type
  return React.useContext(MobXProviderContext) as RootStore;
}

export default useStores;
